<form [formGroup]="form">
  <app-form-control label="Nazwa">
    <input
      [formControl]="form.controls.label"
      appPrimengInputText
      pInputText />
  </app-form-control>

  @if (shouldBeVisible('position')) {
    <app-form-control label="Pozycja / kolejność">
      <input
        [formControl]="form.controls.position"
        appPrimengInputText
        pInputText
        type="number" />
    </app-form-control>
  }

  <div class="flex justify-end">
    <p-button
      (onClick)="handleSubmitClick()"
      [disabled]="form.invalid"
      appPrimengButton
      label="Zapisz"
      severity="primary"
      type="submit" />
  </div>
</form>
